import { Component, Input } from '@angular/core';
import { DEFAULT_APPLICATION_PHONE_NUMBER } from '../../constants';

@Component({
    selector: 'app-support-phone',
    templateUrl: './support-phone.component.html',
    styleUrls: ['./support-phone.component.scss'],
    standalone: false
})
export class SupportPhoneComponent {
  @Input() phone = DEFAULT_APPLICATION_PHONE_NUMBER;
  
  get telHref(): string {
    return 'tel:' + this.phone.replace(/[^\d+]/g, '');
  }
}
